import {Component} from 'panel';

import {Visibility} from 'common/components/base/stackable';
import {promisifyModal} from 'common/components/modal/utils';
import {emitTrackEvent} from 'common/util/dom';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {template} from './template';
import css from './index.inline.styl';

type Rebrand2023ModalState = {
  open: boolean;
};

export class Rebrand2023Modal extends Component<Rebrand2023ModalState> {
  get config() {
    return {
      css,
      template,
      defaultState: {
        open: true,
      },
      useShadowDom: true,
    };
  }

  connectedCallback() {
    super.connectedCallback();
    this.track(`Viewed Rebrand 2023 modal`);
  }

  track(eventName: string): void {
    emitTrackEvent(this, {
      eventName,
    });
  }

  handleReadAboutItButtonClicked = () => {
    this.track(`Clicked Read About It on Rebrand 2023 modal`);
    window.open(`https://mixpanel.com/blog/our-next-step-analytics-for-everyone/`, `_blank`);
    this.update({open: false});
  };

  handleRebrandModalStateChanged = (ev) => {
    if (ev?.detail?.state === Visibility.Closed) {
      this.track(`Closed Rebrand 2023 modal`);
    }
  };
}

export async function promptRebrand2023Modal(): Promise<boolean> {
  const closeEv = await promisifyModal({
    tagName: `mp-rebrand-2023-modal`,
    attrs: {},
    closeEvents: [`close`],
  });

  return closeEv.detail.submitted;
}

export const Rebrand2023ModalEl = defineAndMakeJsxFactory<EmptyObj>(`mp-rebrand-2023-modal`, Rebrand2023Modal);
export const Rebrand2023ModalReact = panel2react<EmptyObj>(`mp-rebrand-2023-modal`, Rebrand2023Modal);
